var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1774_1545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4999 96.9998C75.2856 96.9998 96.9998 75.2856 96.9998 48.4999C96.9998 21.7141 75.2856 0 48.4999 0C21.7141 0 0 21.7141 0 48.4999C0 75.2856 21.7141 96.9998 48.4999 96.9998Z",
    fill: "#EB4B50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.1344 22.5394L53.1341 22.5392C51.9182 21.4069 50.2943 20.7079 48.5051 20.7079C44.7461 20.7079 41.6842 23.7698 41.6842 27.5287C41.6842 30.6813 43.8367 33.3492 46.7569 34.1172V34.9661C36.1365 35.8452 27.7998 44.7375 27.7998 55.5903C27.7998 61.1138 29.9776 66.1194 33.5055 69.8309L33.4954 69.8386L33.6844 70.0276C33.8073 70.1537 33.9316 70.2777 34.0575 70.4009L59.4131 95.7561C75.91 91.9612 89.1848 79.7609 94.4938 63.8988L53.4821 22.887C53.3704 22.767 53.2545 22.6512 53.1344 22.5394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4998 34.3466C44.7409 34.3466 41.6826 31.2881 41.6826 27.5294C41.6826 23.7695 44.7411 20.7111 48.4998 20.7111C52.2592 20.7111 55.3177 23.7695 55.3177 27.5294C55.3177 31.2883 52.2592 34.3466 48.4998 34.3466ZM48.4998 21.6306C45.2479 21.6306 42.6019 24.2768 42.6019 27.5294C42.6019 30.7817 45.2479 33.4273 48.4998 33.4273C51.7524 33.4273 54.3982 30.7819 54.3982 27.5294C54.3982 24.2768 51.7524 21.6306 48.4998 21.6306Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2386 30.0002H46.75V35.6524H50.2386V30.0002Z",
    fill: "#2F4859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4998 76.2902C59.9337 76.2902 69.2027 67.0212 69.2027 55.5873C69.2027 44.1534 59.9337 34.8844 48.4998 34.8844C37.0659 34.8844 27.7969 44.1534 27.7969 55.5873C27.7969 67.0212 37.0659 76.2902 48.4998 76.2902Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4996 72.3857C57.7771 72.3857 65.298 64.8648 65.298 55.5873C65.298 46.3098 57.7771 38.7889 48.4996 38.7889C39.2221 38.7889 31.7012 46.3098 31.7012 55.5873C31.7012 64.8648 39.2221 72.3857 48.4996 72.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7295 40.004H48.2695V41.3048H48.7295V40.004Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7295 69.8612H48.2695V71.162H48.7295V69.8612Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0762 55.3562H62.7754V55.8162H64.0762V55.3562Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2227 55.3562H32.9219V55.8162H34.2227V55.3562Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.087 69.1869L56.4854 68.9569L55.8349 67.8303L55.4366 68.0603L56.087 69.1869Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1642 43.333L41.5625 43.1031L40.9121 41.9765L40.5137 42.2065L41.1642 43.333Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1254 63.5714L36.252 62.921L36.022 62.5227L34.8954 63.1731L35.1254 63.5714Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9827 48.6438L62.1094 47.9935L61.8794 47.5952L60.7528 48.2454L60.9827 48.6438Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8359 43.3405L56.4863 42.214L56.088 41.984L55.4376 43.1105L55.8359 43.3405Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9055 69.1911L41.5557 68.0643L41.1572 67.8344L40.5071 68.9612L40.9055 69.1911Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8794 63.5739L62.1094 63.1756L60.9828 62.5252L60.7528 62.9235L61.8794 63.5739Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0229 48.6552L36.2529 48.2569L35.1264 47.6064L34.8964 48.0048L36.0229 48.6552Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4998 58.9948C48.2457 58.9948 48.04 58.7891 48.04 58.5351V43.6692C48.04 43.4151 48.2457 43.2094 48.4998 43.2094C48.7539 43.2094 48.9596 43.4151 48.9596 43.6692V58.5351C48.9598 58.7891 48.7541 58.9948 48.4998 58.9948Z",
    fill: "#E56353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5002 56.8815C49.215 56.8815 49.7944 56.3021 49.7944 55.5873C49.7944 54.8725 49.215 54.2931 48.5002 54.2931C47.7855 54.2931 47.2061 54.8725 47.2061 55.5873C47.2061 56.3021 47.7855 56.8815 48.5002 56.8815Z",
    fill: "#64798A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8782 27.2555H45.1227C44.846 27.2555 44.6221 27.4797 44.6221 27.7561V30.9365C44.6221 31.2131 44.846 31.4371 45.1227 31.4371H51.8782C52.1548 31.4371 52.3788 31.2131 52.3788 30.9365V27.7561C52.379 27.4797 52.1548 27.2555 51.8782 27.2555Z",
    fill: "#3A556A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1774_1545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.9efdddba16a42520d3af2b2aa53da4be.svg";
export { ForwardRef as ReactComponent };